const getValueByPath = (
  object: Record<string, any> = {},
  path = '',
): string | number | boolean | Record<string, unknown> => {
  const parts = path.split('.');
  return parts.reduce((acc, part): any => (acc || {})[part], object);
};

export { getValueByPath };
